// Generated by `npm --workspace @pleio/icons run generate`, do not edit.
import { type ForwardedRef, forwardRef } from 'react'

import type { IconProps } from '../types'

export const ArrowExitIcon = forwardRef<SVGSVGElement, IconProps>((
    { title, titleId, ...props }: IconProps,
    ref: ForwardedRef<SVGSVGElement>,
) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" display="block" focusable="false" role="img" aria-hidden="true" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<g id="arrow-exit" fill="none" fillRule="nonzero" stroke="none"><path id="Shape" fill="currentColor" d="M2.667 24a2.57 2.57 0 0 1-1.884-.783A2.57 2.57 0 0 1 0 21.333V16h2.667v5.333h18.666V2.667H2.667V8H0V2.667q0-1.1.783-1.884A2.57 2.57 0 0 1 2.667 0h18.666q1.1 0 1.884.783.783.784.783 1.884v18.666q0 1.1-.783 1.884a2.57 2.57 0 0 1-1.884.783zM10 18.667l-1.867-1.934 3.4-3.4H0v-2.666h11.533l-3.4-3.4L10 5.333 16.667 12z" /></g></svg>
))
